// extracted by mini-css-extract-plugin
export default {"detailContent":"AccordionDetails_detailContent__5BBYb","actionText":"AccordionDetails_actionText__hSZu9","cardContainer":"AccordionDetails_cardContainer__SLWrJ"};